export const getShouldForwardPropFn =
	<T extends object>(...propNames: Array<keyof T>) =>
	(prop: string) =>
		!propNames.includes(prop as keyof T);
